import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/financeiro/pagamentos?situacao=${filtro.situacao}&status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/pagamentos/anexos/${pagamentoAnexoId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadPagamentoDocumento(pagamentoDocumentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/pagamentos/documentos/${pagamentoDocumentoId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarReprovarPagamento(aprovaReprovaPagamentoDto) {
        return axiosJwt
            .post(
                `${api}/despesasgerais/financeiro/pagamentos/aprovar`,
                aprovaReprovaPagamentoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/financeiro/pagamentos/${pagamentoId}/anexos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumentosTipos() {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/pagamentos/documentos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumentos(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/financeiro/pagamentos/${pagamentoId}/documentos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoDocumento(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoAnexoId', pagamentoAnexo.tipoId)
        formData.append('descricao', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)

        return axiosJwt
            .post(
                `${api}/despesasgerais/financeiro/pagamentos/${pagamentoAnexo.pagamentoId}/documentos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDocumento(pagamentoDocumento) {
        return axiosJwt
            .put(
                `${api}/despesasgerais/financeiro/pagamentos/${pagamentoDocumento.pagamentoId}/documentos`,
                pagamentoDocumento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCategoriasReprovacao() {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/pagamentos/reprovarpagamentoopcoes`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterNotasFiscais(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/pagamentos/${pagamentoId}/notasfiscais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNotaFiscal(pagamentoNotaFiscalId) {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/pagamentos/notasfiscais/${pagamentoNotaFiscalId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarNotaFiscal(notaFiscal) {
        return axiosJwt
            .put(
                `${api}/despesasgerais/financeiro/pagamentos/${notaFiscal.pagamentoId}/notasfiscais/${notaFiscal.pagamentoNotaFiscalId}`,
                notaFiscal
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadNotaFiscal(pagamentoNotaFiscalId) {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/pagamentos/notasfiscais/${pagamentoNotaFiscalId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposMovimentoDestino(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/pagamentos/${pagamentoId}/tiposmovimentodestino`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    faturarPagamento(pagamentoId, tipoMovimentoDestino) {
        return axiosJwt
            .post(`${api}/despesasgerais/financeiro/pagamentos/${pagamentoId}/faturar`, {
                pagamentoId,
                tipoMovimentoDestino
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

}